/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcolor1Inputs */

const en_entity_contactcolor1 = /** @type {(inputs: Entity_Contactcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Color`)
};

const de_entity_contactcolor1 = /** @type {(inputs: Entity_Contactcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktfarbe`)
};

/**
* | output |
* | --- |
* | "Contact Color" |
*
* @param {Entity_Contactcolor1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcolor1 = /** @type {((inputs?: Entity_Contactcolor1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcolor1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcolor1(inputs)
	return de_entity_contactcolor1(inputs)
});
export { entity_contactcolor1 as "entity_contactColor" }